import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { userSettingsReducer } from './user-settings.reducer';
import { UserSettingsEffects } from './user-settings.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('userSettings', userSettingsReducer),
    EffectsModule.forFeature([UserSettingsEffects])
  ]
})
export class UserSettingsStateModule {}
